<template>
  <v-dialog v-model="modal" max-width="700">
    <v-card>
      <v-card-title>Sauvegarder la recherche</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              autofocus
              filled
              label="Nom de la recherche"
              placeholder="Veuillez saisir un nom"
              append-icon="mdi-book-search"
              v-model.trim="infoRecherche.titre"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="primary"
          :loading="enCours"
          :disabled="!sauvegardePossible"
          @click="sauvegarder"
          >Sauvegarder</v-btn
        >
        <v-btn text @click="annuler">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      infoRecherche: {
        id: null,
        titre: null,
        recherche: null,
      },
      enCours: false,
    };
  },
  computed: {
    sauvegardePossible() {
      return !!this.infoRecherche.titre;
    },
  },
  methods: {
    sauvegarder() {
      this.enCours = true;
      this.$api('/recherche/avancee/mes')
        .post(this.infoRecherche)
        .then(response => {
          this.modal = false;
          this.$emit('change', {
            id: response.body.id,
            titre: this.infoRecherche.titre,
            recherche: this.infoRecherche.recherche,
          });
        })
        .finally(() => {
          this.enCours = false;
        });
    },
    afficher(infoRecherche) {
      this.modal = true;
      this.infoRecherche.id = infoRecherche.id;
      this.infoRecherche.titre = infoRecherche.titre;
      this.infoRecherche.recherche = infoRecherche.recherche;
    },
    annuler() {
      this.modal = false;
    },
  },
};
</script>
